<template>
  <div>
    <iframe
      id="whitelisted-komads"
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
    />

    <ModalBusinessPreferences />

    <ModalFormRejected
      ref="modalPendaftaranDitolak"
      :message="messageReason"
      @on-confirm-button="$bvModal.hide('modal-pendaftaran-ditolak')"
    />

    <ModalTopupKompay
      ref="modalTopupKompay"
      :platform="platform"
      @close="$bvModal.hide('modal-topup-kompay')"
      @showPaymentMethod="$bvModal.show('paymentMethod')"
      @update:isWeekend="val => (isWeekend = val)"
      @update:messageTopup="val => (messageTopup = val)"
    />
    <PaymentMethods
      :is-weekend="isWeekend"
      :message-topup="messageTopup"
      @methodSelected="methodSelected"
    />
    <ScanQRIS
      :qr-bill-detail="qrBillDetail"
      @cancelPayment="cancelPayment"
      @paymentSuccess="paymentSuccess"
      @hidden="qrBillDetail = {}"
    />
    <ModalPaymentExist
      @continuePayment="continuePayment"
      @cancelPayment="cancelPayment"
    />
    <ModalWaitingResponse id="modal-waiting-response" />
    <DrawerTopupWhitelisted
      :is-visible="isVisibleDrawerTopupWhitelisted"
      :whitelisted-accounts="whitelistedAccounts"
      @onVisible="isVisible => showDrawerTopupWhitelisted(isVisible)"
      @onContinueTopup="continueTopup"
      @topupSuccess="id => showSuccessTopup(id, 'topup')"
    />
    <ModalSubscriptionWhitelist
      id="modal-subscription-whitelist"
      @subscribe="id => showSuccessTopup(id, 'subscription')"
    />
    <ModalSuccessTransaction
      id="modal-success-topup"
      :transaction="transactionDetail"
      :source="sourceTransaction"
    />
    <ModalWhitelistSubmissionConfirmation
      id="modal-whitelist-submission-confirmation"
      :platform-name="platform"
      :source="sourceTransaction"
      @onContinue="continueWhitelistSubmissionConfirmation"
    />
    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="functionTransaction"
      @on-cancel-button="$bvModal.hide('modal-verify-pin')"
    />
    <ModalDownloadTopupMutation
      id="modal-download-topup-mutation"
    />
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { isNumber } from '@/libs/helpers'
import { mapState } from 'vuex'
import { newAxiosIns } from '@/libs/axios'
import { mapFields } from 'vuex-map-fields'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import ScanQRIS from '../komship/dashboard/modal/ScanQRIS.vue'
import PaymentMethods from '../komship/dashboard/modal/PaymentMethod.vue'
import ModalPaymentExist from '../komship/dashboard/modal/ModalPaymentExist.vue'
import ModalSuccessTransaction from '../voucher/ModalSuccessTransaction.vue'
import {
  ModalBusinessPreferences,
  ModalTopupKompay,
  ModalFormRejected,
  ModalWaitingResponse,
  ModalSubscriptionWhitelist,
  ModalWhitelistSubmissionConfirmation,
  ModalDownloadTopupMutation,
} from './components'
import DrawerTopupWhitelisted from '../voucher/DrawerTopupWhitelisted.vue'

export default {
  components: {
    ModalPIN,
    ScanQRIS,
    PaymentMethods,
    ModalPaymentExist,
    ModalBusinessPreferences,
    ModalFormRejected,
    ModalWaitingResponse,
    ModalTopupKompay,
    DrawerTopupWhitelisted,
    ModalSubscriptionWhitelist,
    ModalSuccessTransaction,
    ModalWhitelistSubmissionConfirmation,
    ModalDownloadTopupMutation,
  },
  data() {
    return {
      iframeSrc: '#',
      height: 0,
      isNumber,
      IDR,
      loadingTopUp: false,
      dataBillExist: null,
      qrBillDetail: {},
      messageTopup: '',
      isWeekend: false,
      whitelistedAccounts: [],
      transactionDetail: null,
      messageReason: '',
      platform: '',
      sourceTransaction: null,
      isVisibleDrawerTopupWhitelisted: false,
      functionTransaction: () => {},
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
    ...mapFields('saldo', ['nominalTopUp', 'pin']),
  },
  watch: {
    nominalTopUp(newValue) {
      const result = newValue
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      this.$nextTick(() => {
        this.nominalTopUp = `Rp ${result}`
      })
    },
  },
  mounted() {
    this.$store.dispatch('saldo/getBalanceSummary')

    const { wlid } = this.$route.query
    this.iframeSrc = `${process.env.VUE_APP_BASE_AUTH_MODULE}/komads/whitelisted-account`
    if (wlid) this.iframeSrc += `/cpas-detail?wlid=${wlid}`

    window.addEventListener('message', event => {
      const {
        route,
        height,
        modal,
        type,
        description,
        id_trx,
        platform,
      } = event.data

      if (type === 'SET_DIMENSION') {
        this.height = Math.floor(height + 100)
      }

      if (type === 'GET_KOMPAY_BALANCE') {
        this.$store.dispatch('saldo/getBalanceSummary')
      }

      if (modal === 'MODAL_BUSINESS_PREFERENCES') {
        this.$bvModal.show('modal-business-preferences')
      }

      if (type === 'FINISH_SUBMIT_WHITELIST') {
        this.$bvModal.hide('modal-whitelist-submission-confirmation')
      }

      if (modal === 'MODAL_REJECT_REGISTER') {
        this.messageReason = description
        this.$bvModal.show('modal-pendaftaran-ditolak')
      }

      if (modal === 'MODAL_WAITING_RESPONSE') {
        this.$bvModal.show('modal-waiting-response')
      }

      if (modal === 'MODAL_TOP_UP_KOMPAY') {
        this.platform = platform
        this.showModalTopUp()
      }

      if (modal === 'MODAL_TOP_UP_WHITELISTED') {
        this.nominalTopUp = ''
        this.getWhitelistedAccounts()
        this.showDrawerTopupWhitelisted(true)
      }

      if (modal === 'MODAL_DOWNLOAD_TOP_UP_MUTATION') {
        this.$bvModal.show('modal-download-topup-mutation')
        return
      }

      if (modal === 'MODAL_SUBSCRIPTION_WHITELIST') {
        this.$bvModal.show('modal-subscription-whitelist')
      }

      if (modal === 'MODAL_DETAIL_HISTORY_TRANSACTION') {
        const source = type === 'subscription' ? 'subscription' : 'topup'
        this.showSuccessTopup(id_trx, source)
      }

      if (modal === 'MODAL_WHITELIST_SUBMISSION_CONFIRMATION') {
        this.continueTopup({
          platformName: platform,
          actionFunction: this.continueWhitelistSubmission,
          source: 'subscription',
        })
      }

      if (type === 'STEP_BACK_PAGE') {
        this.$router.replace({
          query: {},
        })
      }

      if (route) {
        this.$router.push(route)
      }
    })
  },
  methods: {
    continueTopup({ platformName, actionFunction, source }) {
      if (!['subscription', 'topup'].includes(source)) return

      this.platform = platformName
      this.functionTransaction = actionFunction
      this.sourceTransaction = source
      this.$bvModal.show('modal-whitelist-submission-confirmation')
    },
    continueWhitelistSubmissionConfirmation() {
      this.$bvModal.show('modal-verify-pin')
    },
    showDrawerTopupWhitelisted(isVisible = false) {
      this.isVisibleDrawerTopupWhitelisted = isVisible
    },
    formatNumber(value) {
      if (!value) return 0
      return Number(value.toString().replace(/[^0-9]/g, ''))
    },
    createPIN(value) {
      this.dataPin = value
      this.$bvModal.show('confirm-create-pin')
    },
    showModalTopUp() {
      this.nominalTopUp = ''
      this.$refs.modalTopupKompay.showModal()
    },
    async handleTopup() {
      try {
        const response = await this.$store.dispatch('saldo/checkActiveBill')
        const { data } = response
        if (data.data.have_active_bill) {
          this.dataBillExist = data.data
          this.$bvModal.show('modalPaymentExist')
        } else {
          this.showModalTopUp()
        }
        if (!data.status) throw data
      } catch (e) {
        this.$swal({
          title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
          text: e.message,
          // eslint-disable-next-line global-require
          imageUrl:
            'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
          confirmButtonText: 'Oke',
          confirmButtonClass: 'btn btn-primary',
        })
      }
    },
    async methodSelected(method) {
      if (method === 'qris' && !this.isWeekend) {
        try {
          const response = await this.$store.dispatch('saldo/qrisTopup')
          const { data } = response

          if (!data.status) throw data

          if (data.data) {
            const {
              amount, expires_at, qr_string, id,
            } = data.data

            this.qrBillDetail = {
              amount,
              expire: expires_at,
              qrString: qr_string,
              qrId: id,
            }

            this.$bvModal.hide('paymentMethod')
            this.$bvModal.show('scanQris')
          }
        } catch (e) {
          this.$refs.modalTopupKompay.hideModal()
          this.loadingTopUp = false
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        }
      }
      if (method === 'bank') {
        this.$bvModal.hide('paymentMethod')

        const result = this.formatNumber(this.nominalTopUp)
        this.nominalTopUp = `Rp ${result}`
        this.loadingTopUp = true
        try {
          const response = await this.$store.dispatch(
            'saldo/newTopUpSaldo',
            true,
          )
          const { data } = response
          if (!data.status) throw data
          try {
            this.$refs.modalTopupKompay.hideModal()
            window.open(data.data.invoice_url, '_blank').focus()
          } catch (e) {
            this.$refs.modalTopupKompay.hideModal()
            this.loadingTopUp = false
            this.$toast_error({
              message:
                'Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.',
            })
          }
          this.$refs.modalTopupKompay.hideModal()
          this.$bvModal.hide('paymentMethod')
          this.loadingTopUp = false
          this.$swal({
            html:
              'Silahkan selesaikan pembayaran terlebih dahulu untuk memastikan proses Top Up Saldo Berhasil<br><br><b>Sudah menyelesaikan pembayaran?</b>',
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
            confirmButtonText: 'Cek Rincian Saldo',
            confirmButtonClass: 'btn btn-primary',
          }).then(then => {
            if (then.isConfirmed) {
              this.$router.push('/keuangan/saldo/detail')
            }
          })
        } catch (e) {
          this.$refs.modalTopupKompay.hideModal()
          this.loadingTopUp = false
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        } finally {
          this.$store.commit('saldo/UPDATE_NOMINAL', '')
        }
      }
    },
    async continuePayment() {
      if (!this.dataBillExist.invoice_xendit_url) {
        const {
          qr_amount,
          qr_expire_date,
          qr_xendit_qrstring,
          qr_xendit_id,
        } = this.dataBillExist

        this.qrBillDetail = {
          amount: qr_amount,
          expire: qr_expire_date,
          qrString: qr_xendit_qrstring,
          qrId: qr_xendit_id,
        }

        this.$bvModal.show('scanQris')
      } else {
        this.$bvModal.hide('modalPaymentExist')
        try {
          window.open(this.dataBillExist.invoice_xendit_url, '_blank').focus()
        } catch (e) {
          this.$toast_error({
            message:
              'Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.',
          })
        }
        this.$refs.modalTopupKompay.hideModal()
        this.loadingTopUp = false
        this.$swal({
          html:
            'Silahkan selesaikan pembayaran terlebih dahulu untuk memastikan proses Top Up Saldo Berhasil<br><br><b>Sudah menyelesaikan pembayaran?</b>',
          imageUrl:
            'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
          confirmButtonText: 'Cek Rincian Saldo',
          confirmButtonClass: 'btn btn-primary',
        }).then(then => {
          if (then.isConfirmed) {
            this.$router.push('/keuangan/saldo/detail')
          }
        })
      }
    },
    async cancelPayment(qr) {
      try {
        const response = (await !qr) && this.dataBillExist.invoice_xendit_id
          ? this.$store.dispatch(
            'saldo/cancelActiveBill',
            this.dataBillExist.invoice_xendit_id,
          )
          : this.$store.dispatch(
            'saldo/cancelQrBill',
            qr || this.dataBillExist.qr_xendit_id,
          )
        const { data } = await response
        if (data.code === 200) {
          this.$toast_success({
            message: 'Berhasil membatalkan pembayaran',
          })

          this.$bvModal.hide('modalPaymentExist')
          this.$bvModal.hide('scanQris')
          this.$bvModal.hide('modal-topup-kompay')
          this.loadingTopUp = false
        }
        if (!data.status) throw data
      } catch ({ response }) {
        if (
          response.status === 400
          || (response.status === 404
            && response.data.data.detail === 'could not find invoice by id')
        ) {
          this.$toast_success({
            message: 'Pembayaran sudah berhasil dilakukan',
          })
          this.$bvModal.hide('modalPaymentExist')
          this.$store.dispatch('saldo/getBalanceSummary')
        } else {
          this.$swal({
            title:
              '<span class="font-semibold h4">Pembatalan Pembayaran Gagal</span>',
            text: response.data.data,
            // eslint-disable-next-line global-require
            imageUrl:
              'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        }
      }
    },
    paymentSuccess(message) {
      this.$toast_success({
        message,
      })

      this.$store.dispatch('saldo/getBalanceSummary')
      this.$bvModal.hide('scanQris')
      this.$bvModal.hide('modalPaymentExist')
      this.loadingTopUp = false
      this.$bvModal.hide('modal-topup-kompay')

      const postMessage = { type: 'GET_STATUS_ONBOARDING' }
      const iframe = document.querySelector('#whitelisted-komads')
      iframe.contentWindow.postMessage(postMessage, '*')
    },

    async getWhitelistedAccounts() {
      await newAxiosIns
        .get('/komads/api/v1/whitelist_accounts/list')
        .then(res => {
          const { data } = res
          this.whitelistedAccounts = data.data
        })
    },

    async fetchDetailTransaction(id) {
      await newAxiosIns
        .get(`komads/api/v1/whitelist_accounts/transactions/${id}`)
        .then(res => {
          this.transactionDetail = res.data.data
        })
    },
    /**
     * Show success topup modal
     * @param {string} id - Transaction ID or object containing transaction data
     * @param {string} source - Source of the transaction ('subscription' or 'topup')
     */
    async showSuccessTopup(id, source = 'topup') {
      await this.fetchDetailTransaction(id)

      // Determine title based on source
      if (source === 'subscription') {
        this.sourceTransaction = 'subscription'
      } else {
        this.sourceTransaction = 'topup'
      }

      this.$bvModal.show('modal-success-topup')
    },
    continueWhitelistSubmission(pin) {
      const postMessage = { type: 'POST_WHITELIST_SUBMISSION', data: { pin } }
      const iframe = document.querySelector('#whitelisted-komads')
      iframe.contentWindow.postMessage(postMessage, '*')
    },
  },
}
</script>
